import AppResource from '@milestoneslabs/milestones-js-engine/src/Data/AppResource';
import FileAppResource from './FileAppResource';
import LuProcessOutputTypeAppResource from './LuProcessOutputTypeAppResource';
import ProcessAppResource from './ProcessAppResource';
import ProcessInputAppResource from './ProcessInputAppResource';
import StageTypeAppResource from './StageTypeAppResource';

class ProcessOutputAppResource extends AppResource {

    /**
     * @returns {string}
     */
    appResourceType() {
        return 'process-output';
    }

    /**
     * @returns {string}
     */
    appResourceApiPrefix() {
        return 'processes/outputs';
    }

    /**
     * @returns {*[]}
     */
    hidden() {
        return super.hidden().concat([
            'uuid',
            'deleted_at',
        ]);
    }

    /**
     * @returns {*[]}
     */
    fillable() {
        return [
            'processOutputTypeId',
            'processInputUuid',
            'conditionInputUuid',
            'processUuid',
            'stageTypeUuid',
            'parentUuid',
            'title',
            'description',
            'offsetType',
            'offsetDays',
            'meta',
            'outputType',
            'processInput',
            'conditionInput',
            'process',
            'stageType',
            'children',
            'parent',
            'files',
        ];
    }

    /**
     * @returns {*[]}
     */
    relationMap() {
        return {
            outputType: LuProcessOutputTypeAppResource,
            processInput: ProcessInputAppResource,
            conditionInput: ProcessInputAppResource,
            process: ProcessAppResource,
            stageType: StageTypeAppResource,
            children: ProcessOutputAppResource,
            parent: ProcessOutputAppResource,
            files: FileAppResource,
        };
    }

    /**
     * @returns {*[]}
     */
    relationForeignKeys() {
        return {
            outputType: 'process_output_type_id',
            processInput: 'process_input_uuid',
            conditionInput: 'condition_input_uuid',
            process: 'process_uuid',
            stageType: 'stage_type_uuid',
            parent: 'parent_uuid',
        };
    }

    /**
     * @returns {*}
     */
    validationRules() {
        return {
            processOutputTypeId: {
                presence: true,
                numericality: true,
            },
            processInputUuid: {
                type: 'string',
            },
            conditionInputUuid: {
                type: 'string',
            },
            processUuid: {
                type: 'string',
                presence: true,
            },
            stageTypeUuid: {
                type: 'string',
                presence: true,
            },
            parentUuid: {
                type: 'string',
            },
            title: {
                type: 'string',
                presence: true,
                length: {
                    maximum: 255,
                },
            },
            description: {
                type: 'string',
            },
            offsetType: {
                type: 'string',
                length: {
                    maximum: 255,
                },
            },
            offsetDays: {
                type: 'string',
            },
            meta: {
                array: {
                    items: {
                        type: 'string',
                    },
                },
            },
        };
    }

}

export default ProcessOutputAppResource;
